export const GET_TASKS_REQUEST = "GET_TASKS_REQUEST";
export const GET_TASKS_SUCCESS = "GET_TASKS_SUCCESS";
export const GET_TASKS_FAILURE = "GET_TASKS_FAILURE";

export const ADD_TASK_REQUEST = "ADD_TASK_REQUEST";
export const ADD_TASK_SUCCESS = "ADD_TASK_SUCCESS";
export const ADD_TASK_FAILURE = "ADD_TASK_FAILURE";

export const DELETE_TASK_REQUEST = "DELETE_TASK_REQUEST";
export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS";
export const DELETE_TASK_FAILURE = "DELETE_TASK_FAILURE";

export const UPDATE_TASKS_REQUEST = "UPDATE_TASKS_REQUEST";
export const UPDATE_TASKS_SUCCESS = "UPDATE_TASKS_SUCCESS";
export const UPDATE_TASKS_FAILURE = "UPDATE_TASKS_FAILURE";

export const ADD_SUBTASKS_REQUEST = "ADD_SUBTASKS_REQUEST";
export const ADD_SUBTASKS_SUCCESS = "ADD_SUBTASKS_SUCCESS";
export const ADD_SUBTASKS_FAILURE = "ADD_SUBTASKS_FAILURE";

export const DELETE_SUBTASKS_REQUEST = "DELETE_SUBTASKS_REQUEST";
export const DELETE_SUBTASKS_SUCCESS = "DELETE_SUBTASKS_SUCCESS";
export const DELETE_SUBTASKS_FAILURE = "DELETE_SUBTASKS_FAILURE";

export const UPDATE_SUBTASKS_STATUS_REQUEST = "UPDATE_SUBTASKS_STATUS_REQUEST";
export const UPDATE_SUBTASKS_STATUS_SUCCESS = "UPDATE_SUBTASKS_STATUS_SUCCESS";
export const UPDATE_SUBTASKS_STATUS_FAILURE = "UPDATE_SUBTASKS_STATUS_FAILURE";
